import { all, takeLatest } from 'redux-saga/effects';

import { BILLING_LIST_REQUEST, BILLING_SET_FILTER, GET_ONGOING_TRIP_RECEIPTS } from '../../redux/billing/types';

import list from './list';
import { getOngoingTripReceiptsSaga } from './getOngoingTripReceiptsSaga';

export default function*() {
    yield all([
        takeLatest(BILLING_LIST_REQUEST, list),
        takeLatest(BILLING_SET_FILTER, list),
        takeLatest(GET_ONGOING_TRIP_RECEIPTS, getOngoingTripReceiptsSaga),
    ]);
}
